import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { DashboardGridComponent } from './dashboard-grid/dashboard-grid.component';
import { LeadsDoDialComponent } from './leads-do-dia.component/leads-do-dia.component';

@Component({
  selector: 'app-homepage',
  imports: [CommonModule, DashboardGridComponent, LeadsDoDialComponent],
  templateUrl: './homepage.html',
  styleUrl: './homepage.css',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class Homepage implements OnInit {

  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    this.authService.getPermissoesPorSlug('homepage');
  }
}
